import React, { useEffect, useState } from 'react';
import { Col, Input, Popover, Radio, Row, Tabs } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import LoanTabDatas from '../LoanApplicationCases/LoanTabDatas';
import PageLoader from '../../components/PageLoader';
import { ServerAPI } from '../../common/ServerAPI';
import { setLoanApplicationFilter } from '../../redux/slice/loanFilterSlice';

const DealerCommisionReport = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const pagePermission = location.state
  const loanAppFilters = useSelector(
    (state) => state.loanProductFilter?.loanApplicationFilters
  );
  const [loading, setLoading] = useState(false);
  const [listDetails, setListDetails] = useState([]);

  const [applyFilters, setApplyFilters] = useState(
    Object.keys(loanAppFilters)?.length > 0
      ? loanAppFilters
      : {
        sortKey: 'created_at',
        sortOrder: 'desc',
        filter: '2',
        index: 1,
        provider_type: 'all',
        keyword: '',
      }
  );

  const LoanCaseList = async () => {
    const response = await ServerAPI.applicationList({
      ...applyFilters,
      provider_type:
        applyFilters?.provider_type === 'all'
          ? ''
          : applyFilters?.provider_type,
    });
    if (response) {
      if (response.data) {
        setLoading(false);
        setListDetails(response.data);
      }
    }
  };

  useEffect(() => {
    LoanCaseList();
  }, []);


  useEffect(() => {
    LoanCaseList();
  }, [applyFilters]);



  if (loading) {
    return <PageLoader />;
  }

  return (
    <div className='w-full min-h-screen bg-[#F5F5F5] overflow-x-clip'>
      <div className='bg-white'>
        <div className='flex pt-[20px] justify-between items-center px-[24px] max-[600px]:flex-col max-[600px]:items-start'>
          <div className='flex items-baseline justify-between w-full md:w-fit'>
            <div className='font-[700] text-[20px] max-[600px]:mb-[15px]'>
              Dealer Commision Report
            </div>
          </div>
        </div>
        <div className='app-container p-[10px_25px]'>
          <LoanTabDatas
            data={listDetails}
            type={'completed_disbursement'}
            pagePermission={pagePermission}
            fetchLoanCase={LoanCaseList}
          />
        </div>
      </div>
    </div>
  );
};

export default DealerCommisionReport;
